const article = {
	slug: "one-more-prompt",
	title: "One More Prompt Syndrome",
	date: "9 June 2026",
	updated: null,
	description:
		"AI tools removed the natural stopping points that used to end the workday. So I built a Claude Code skill that interrupts you in your own dialect when you have been at it too long.",
	keywords: [
		"AI tools",
		"developer productivity",
		"Zeigarnik effect",
		"Claude Code",
		"building in public",
	],
	tldr: "The compile failed, the office closed, you went home. AI tools have no natural stopping point. The real question is not how to get engineers to start using AI. It is what helps them stop.",
	readingTime: null,
	provenance: "Adapted from my LinkedIn post, June 2026.",
	provenanceUrl: null,
	series: null,
	artifact: null,
	markdown: `DSM-6 does not have a diagnosis for this yet. I call it "one more prompt" syndrome.

You open an AI tool to fix something small. Done in 20 minutes. And then you are still there three hours later, refactoring things that weren't broken, asking questions you won't remember by morning.

ChatGPT, Cursor, Google Gemini. Doesn't matter which one. Every engineer I work with has a version of this story. The tools are too willing.

## There is a name for why you cannot stop

The Zeigarnik Effect. Bluma Zeigarnik noticed in 1927 that waiters remembered unpaid tabs better than settled ones. Unfinished things keep tugging at your attention. It is why browser tabs stay open.

I write about human-AI balance. I also cannot stop. Claude does not sleep. Claude does not get lower back pain. Claude is not you.

None of us have a stopping mechanism with such power at our disposal.

## So I built one

A Claude Code skill called /chill. It comes with 15+ language packs designed to interrupt you like a street-smart friend, not a wellness app.

Mine is set to Mumbai tapori. It interrupts me when I have been at it too long: "bhai thanda le zara, bahut vibe coding kar liye ho." I used Claude to build a tool that tells me to stop using Claude.

It triggers automatically in the background, or you can just type /chill when you feel the slope starting. Yesterday, I was over-engineering my model selection, and it came back:

> "tune abhi API cost compare kiya. Matlab tu abhi productivity calculate kar raha hai, kaam nahi. Chal band kar."
>
> (Translation: "You just compared API costs. Meaning you're calculating productivity right now, not actually working. Shut it down.")

It called out the exact activity. I have open sourced it, and more languages are welcome at [github.com/swapniltamse/one-more-prompt](https://github.com/swapniltamse/one-more-prompt).

## The real question

With 100x software development expectations and token-maxxing goals, maybe the question is not how we get engineers to start using AI.

It is this: what helps them stop?`,
};

export default article;
